import React from "react";
import styled from "styled-components/macro";
import fbimg from "../assets/fb-icon.png";
import linkedinimg from "../assets/linkedin-icon.png";
import twitterimg from "../assets/twitter-icon.png";
import instaimg from "../assets/insta_icon.png";
import clsx from "clsx";

function Footer() {
  return (
    <footer
      id="footer"
      className="text-white sm:text-left text-center max-w-[100vw] ">
      <Container>
        <div className="">
          <div className="grid sm:grid-cols-2 gap-4 pb-20 ">
            <div className={clsx("contactus", "md:mr-auto", "pt-6")}>
              <div className="font-titilium text-[30px] font-extrabold mb-4">
                HAVE ANY QUESTIONS?
              </div>
              <div className="font-light text-[16px] ">
                Send your questions to
                <div className="text-[20px] font-normal">
                  IN48Partner@fisglobal.com
                </div>
              </div>
            </div>
            <div className="connected mx-auto pt-6">
              <div className="">Stay Connected</div>
              <div className="socialimgs flex justify-between">
                <a href="https://www.facebook.com/FIStoday/"><img src={fbimg} width="32px" className="mr-2 my-2"></img></a>
                <a href="https://www.linkedin.com/company/fis/"><img src={linkedinimg} width="32px" className="mr-2 my-2"></img></a>
                <a href="https://twitter.com/fisglobal"><img src={twitterimg} width="32px" className="mr-2 my-2"></img></a>
                <a href="https://www.instagram.com/fis_global/"><img src={instaimg} width="32px" className="mr-2 my-2"></img></a>
              </div>
            </div>
            {/* <div className={clsx("support", "md:ml-auto", "pt-6")}>
              <a href="#/">
                <div className="py-2 pt-0">
                  Customer Support <span className="arrow">˃</span>
                </div>
              </a>
              <a href="#/">
                <div className="py-2">
                  Terms of Use <span className="arrow">˃</span>
                </div>
              </a>
              <a href="#/">
                <div className="py-2">
                  Privacy Policy <span className="arrow">˃</span>
                </div>
              </a>
            </div> */}
          </div>
          <div className="copyright text-center font-light text-sm py-6">
          © FIS 2022. Advancing the way the world pays, banks and invests™
          </div>
        </div>
      </Container>
    </footer>
  );
}

const Container = styled.div`
  --max-width: 1064px;
  --padding: 1rem;
  width: min(var(--max-width), 100% - var(--padding) * 2);
  margin-inline: auto;
`;

export default Footer;
